import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logowithname.svg";
import { getRequest } from "../apiRequests/requestApi";
import { formatDateString } from "../../utils";
import { Spinner } from "react-bootstrap";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const notificationsPerPage = 4;
  const navigate = useNavigate();
  
const handleGamerClick = (user) => {
  if (!user?.senderInformation?.userId) return;
  navigate("/chat", {
    state: {
      selectedUser: {
        _id: user.senderInformation.userId,
        name: user.senderInformation.username,
        avatar: user.senderInformation.avatar || user.senderInformation.profile,
        username: user.senderInformation.username,
      },
    },
  });
};

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getRequest("/notifications");

        if (!response.data) {
          setNotifications([]);
          return;
        }
        
        const newArray = response.data.map((notif) => {
          const isUserMsg =
            notif.senderInformation &&
            typeof notif.senderInformation === "object" &&
            notif.senderInformation.username;
          return {
            id: notif._id || notif.id,
            image: isUserMsg
              ? notif?.senderInformation?.avatar
              : notif.image || logo,
            text: notif.body,
            title: notif.title,
            date: formatDateString(notif.createdAt, "long"),
            senderName: isUserMsg
              ? `${(notif.senderInformation.firstName || "").trim()} ${(notif.senderInformation.lastName || "").trim()}`
              : "Skyboard",
            type: isUserMsg ? "user" : "system",
            read: notif.read,
            preview: notif.body,
            senderInformation: isUserMsg ? notif.senderInformation : null,
          };
        });

        setNotifications(newArray);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  const indexOfLast = currentPage * notificationsPerPage;
  const indexOfFirst = indexOfLast - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(notifications.length / notificationsPerPage);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const displayNotifications = currentNotifications.map((notify, i) => {
    const {
      text,
      date,
      image,
      type,
      title,
      senderName,
      read,
      senderInformation,
    } = notify;
    return (
     <div
  key={i}
  onClick={senderName ? () => handleGamerClick(notify) : undefined}
  className={`relative flex flex-row items-start md:items-center gap-4 p-3 rounded-2xl shadow-md mb-4 transition-shadow ${
    read
      ? "bg-white/10 text-white border border-gray-800"
      : "bg-[#23272f] text-[#E7FDB7] border-2 border-[#E7FDB7]"
  } ${senderName ? "cursor-pointer hover:shadow-lg" : ""}`}
>

        {!read && (
          <span className="absolute top-2 left-2 w-3 h-3 rounded-full bg-[#E7FDB7] border-2 border-[#23272f]" />
        )}
        <div className="flex-shrink-0">
          <img
            src={image || logo}
            onError={(e) => (e.target.src = logo)}
            alt={senderName}
            className="w-14 h-14 rounded-full object-cover border-[2.5px] border-[#E7FDB7] shadow-sm bg-[#232323]"
          />
        </div>
        <div className="flex-1">
          {title && <h5 className="text-md font-semibold">{title}</h5>}
          {senderName && (
            <p className="text-sm font-medium text-[#E7FDB7]">{senderName} sent:</p>
          )}
          <p
            className={`mt-1 text-sm ${
              read ? "font-normal text-white/90" : "font-semibold"
            }`}
          >
            {text}
          </p>
          <p className="text-xs text-[#BD3193] mt-1 opacity-70">{date}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="dashboard">
      <div className="d-flex flex-wrap justify-content-between col-lg-12 w-100 col-12">
        <div className="col-lg-9 col-md-9 col-12 px-lg-5 px-md-5 px-2 bg-[#130828]">
          <div className="flex items-center gap-24 my-10">
            <button
              onClick={() => navigate("/")}
              className="text-white"
              style={{ background: "none", border: "none", padding: 0 }}
            >
              <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
              <span className="font-poppins text-xl font-bold">
                <AiOutlineArrowLeft width={30} height={30} />
              </span>
            </button>
            <h2 className="text-2xl text-white text-center font-semibold">
              Notifications
            </h2>
          </div>

          {loading ? (
            <div className="flex items-center gap-2 text-white">
              <p className="text-sm font-semibold">
                Retrieving notifications...
              </p>
              <Spinner size="sm" variant="light" />
            </div>
          ) : notifications.length > 0 ? (
            <>
              {displayNotifications}
              <div className="flex justify-center items-center mt-6 gap-4">
                <button
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                  className="px-4 py-1 border border-white rounded-lg text-white hover:bg-white hover:text-black transition disabled:opacity-40"
                >
                  Prev
                </button>
                <span className="text-white text-sm">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className="px-4 py-1 border border-white rounded-lg text-white hover:bg-white hover:text-black transition disabled:opacity-40"
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p className="text-white text-sm font-semibold">
              No notifications found
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
